<template>
	<div>
		<Header />
		<div id="wrap">
			<div id="inner">
				<keep-alive>
					<router-view :key="$route.fullPath" />
				</keep-alive>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
// const axios = require('axios');


//
export default {
	name: 'App',
	components: {
		Header,
		Footer
	},
	data: function() {
		return {}
	},
	computed: {},
	methods: {}
};
</script>

<style src="./styles/app.scss" lang="scss" />